module.exports = __webpack_public_path__ + "static/media/006yhkgl.97a3c3d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/006yhkgl.jpg
// module id = 630
// module chunks = 0 1